import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

import AboutIntro from "../../components/AboutIntro/AboutIntro";
import CardSlider from "../../components/carousel/Carousel";
import CaseStudies from "../../components/CaseStudies/CaseStudies";
import Blog from "../../components/Blog/Blog";
import GetInTouch from "../../components/GetInTouch/GetInTouch";

import "./About.css";

function About() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="about-page">
      <AboutIntro />

      <CardSlider />

      <CaseStudies />

      <section className="founder-quote" aria-labelledby="founder-quote-title">
        <div className="founder-quote__decoration" aria-hidden="true" />

        <div className="founder-quote__container">
          <span className="founder-quote__index" aria-hidden="true">
            AX / Perspective
          </span>

          <div className="founder-quote__content">
            <p className="founder-quote__eyebrow">
              <span aria-hidden="true" />
              Founder perspective
            </p>

            <FontAwesomeIcon
              icon={faQuoteLeft}
              className="founder-quote__icon"
              aria-hidden="true"
            />

            <figure className="founder-quote__figure">
              <blockquote>
                <p id="founder-quote-title">
                  Empowering businesses with tailored technology solutions for a
                  smarter, more connected future.
                </p>
              </blockquote>

              <figcaption>
                <strong>Shiwanshu Pandey</strong>
                <span>Founder &amp; CEO, Axiomos Technologies LLP</span>
              </figcaption>
            </figure>
          </div>

          <div className="founder-quote__footer">
            <p>
              Have a business challenge in mind? Let’s explore how the right
              technology can move it forward.
            </p>

            <Link
              to="/contact"
              className="founder-quote__cta"
              onClick={scrollToTop}
            >
              Start a conversation
              <span aria-hidden="true">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </Link>
          </div>
        </div>
      </section>

      <Blog />

      <GetInTouch />
    </main>
  );
}

export default About;
